module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-cell', {
    attrs: {
      "title": _vm.label,
      "isLink": "",
      "disabledcolor": _vm.readonly || _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleDisplayClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "select-value"
  }, [
    [_vm._v(_vm._s(_vm.singleSelectDisplay()))]
  ], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectorShow),
      expression: "selectorShow"
    }],
    staticClass: "select-container mt-bg-lv1",
    style: ({
      height: _vm.cHeight + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [
    [_c('div', {
      staticClass: "select-container-title mt-color-grey-lv3"
    }, [_vm._v(_vm._s(_vm.label + "："))]), _vm._v(" "), _c('mt-textarea', {
      attrs: {
        "placeholder": _vm.placeholder,
        "rows": _vm.rows,
        "wrapperpaddingleft": "15px",
        "readonly": true
      },
      model: {
        value: (_vm.currentValue),
        callback: function($$v) {
          _vm.currentValue = $$v
        },
        expression: "currentValue"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "select-container-buttons"
    }, _vm._l((_vm.options), function(opt) {
      return _c('div', {
        staticClass: "select-container-button",
        class: [opt.active ? 'mt-bColor-primary mt-color-primary mt-bg-primary-opacity1' : 'mt-bColor-grey-lv4 mt-color-grey-lv2 mt-bg-lv3'],
        on: {
          "click": function($event) {
            _vm.selectOption(opt)
          }
        }
      }, [_vm._v(_vm._s(opt.name) + "\n          ")])
    })), _vm._v(" "), _c('div', {
      staticClass: "select-container-confirm"
    }, [_c('mt-button', {
      attrs: {
        "size": "large",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectorShow = false
        }
      }
    }, [_vm._v("确定")])], 1)]
  ], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896bc102","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/text-select/src/text-select.vue
// module id = 305
// module chunks = 0